import { useRef } from 'react';

const useFallbackRef = (forwardedRef) => {
  const fallbackRef = useRef(null);
  return forwardedRef || fallbackRef;
};

export default useFallbackRef;
